import { render, staticRenderFns } from "./ModifyHeadUser.vue?vue&type=template&id=2785983f"
import script from "./ModifyHeadUser.vue?vue&type=script&lang=js"
export * from "./ModifyHeadUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports